import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tag from '.';

const Vehicle = (props: React.ComponentProps<typeof VisibilityIcon>) => (
  <Tag style={{ boxShadow: 'none', padding: 0 }}>
    <VisibilityIcon
      style={{ width: '16px', height: '16px' }}
      color="inherit"
      {...props}
    />
  </Tag>
);

export default Vehicle;
